import { TOGGLE_SIDEBAR } from "./types";

export default {
  [TOGGLE_SIDEBAR](state) {
    state.sidebar.open = !state.sidebar.open;
  }
};
